/** Janela em que candidatos que chegam juntos viram um popup só. */
export const STORE_NUDGE_CONSOLIDATION_MS = 15_000

/** Intervalo mínimo entre o fechamento de um popup e a abertura do próximo. */
export const STORE_NUDGE_COOLDOWN_MS = 300_000

/** Miniaturas na faixa antes de colapsar em "+N". */
export const STORE_NUDGE_THUMBS_CAP = 4

export const STORE_NUDGE_STORAGE_PREFIX = 'store-nudge:v1'

export type StoreNudgeHeroAsset = {
  /** Fallback WebP em 1x. */
  src: string
  /** Densidades em WebP, para `srcSet`. */
  webpSrcSet: string
  /** Mesmas densidades em AVIF, para `<source>`. */
  avifSrcSet: string
}

const heroAsset = (name: string): StoreNudgeHeroAsset => ({
  src: `/store-nudge/${name}.webp`,
  webpSrcSet: `/store-nudge/${name}.webp 1x, /store-nudge/${name}@2x.webp 2x, /store-nudge/${name}@3x.webp 3x`,
  avifSrcSet: `/store-nudge/${name}.avif 1x, /store-nudge/${name}@2x.avif 2x, /store-nudge/${name}@3x.avif 3x`
})

/**
 * Ilustração fixa do topo, uma por caso: a lojinha com moedas para o gatilho de
 * saldo, o cadeado aberto para o desbloqueio. São artes distintas porque os dois
 * popups dizem coisas diferentes — "já dá para trocar" e "apareceu algo novo".
 */
export const STORE_NUDGE_HERO: Record<'afford' | 'unlocked', StoreNudgeHeroAsset> = {
  afford: heroAsset('hero'),
  unlocked: heroAsset('unlocked')
}

export const STORE_NUDGE_COPY = {
  afford: {
    title: 'Você já tem moedas suficientes! 🎉',
    subtitle:
      'Agora você já pode trocar por este item e muitos outros na lojinha!'
  },
  unlocked: {
    title: 'Parabéns! ✨',
    subtitleOne: 'Você desbloqueou um novo item na lojinha.',
    subtitleMany: (count: number) =>
      `Você desbloqueou ${count} novos itens na lojinha.`
  },
  affordSecondary: (name: string) =>
    `E suas moedas já dão pra trocar pelo item ${name}!`,
  othersCount: (count: number) =>
    `E tem mais ${count} ${count === 1 ? 'item esperando' : 'itens esperando'} por você!`,
  unlockedBadge: 'Desbloqueado',
  primaryAction: 'Ver a lojinha',
  secondaryAction: 'Depois'
} as const
